import Vue from 'vue'
import Vuex from 'vuex'
import globalAxios from 'axios'
// import _ from 'lodash'

Vue.use(Vuex);

// let base = 'http://127.0.0.1:12345/';
// if (location.href.toLowerCase().indexOf('azurewebsites') > -1) {
//     base = 'https://articlesofinterest-api-heroku.herokuapp.com/';
// } else if (location.href.toLowerCase().indexOf('azurewebsites') > -1 ||
//   location.href.toLowerCase().indexOf('articlesofinterest.site') > -1) {
//     // base = 'https://azurearticlesofinterestservice.azurewebsites.net/'
//     base = 'https://articlesofinterestapi.azurewebsites.net/'
// }

let base ="https://articlesofinterestapi.azurewebsites.net/"

let config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*' // means nothing.. response header is what is important
    }
};

export default new Vuex.Store({
    state: {
        storedArticles: [],
        selectedArticles: [],
        recommendedArticles: [],
        newArticles: false,
        articleSummary: '',
        yearArticles: null,
        totalSelectedArticles: null
        // start: 0,
        // end: 200
    },
    mutations: { //reducer
        // selectRange(state,start,end){
        //     state.start=start;
        //     state.end=end
        // },
        totalSelectedArticles(state, length) {
            // if(data.isNew){
            setTimeout(() => {
                state.totalSelectedArticles = length
            }, 10)
            // }
        },
        yearArticles(state, year) {
            state.yearArticles = year;
        },
        newArticles(state, isNew) {
            state.newArticles = isNew;
        },
        selectedArticles(state, articles) {
            setTimeout(() => {
                state.selectedArticles = articles;
            }, 10)
        },
        storeArticles(state, articles) {
            setTimeout(() => {
                state.storedArticles = articles;
            }, 10)
        },
        articleSummary(state, summary) {
            state.articleSummary = summary;
        }
        , recommendedArticles(state, recommended) {
            state.recommendedArticles = recommended;
        }
    },
    actions: {
        selectedArticles({commit, dispatch}, data) {
            commit('selectedArticles', data.data);// commit to mutation

            dispatch('newArticles', data.isNew); // dispatch to action
        },
        totalSelectedArticles({commit}, length) {
            commit('totalSelectedArticles', length);
        },
        newArticles({commit}, isArticles) {
            commit('newArticles', isArticles);
        },
        storedArticles({commit, dispatch}, year) {
            // show the progress bar
            dispatch('selectedArticles', {data: [], isNew: true});
            commit('storeArticles', []);

            //get data
            setTimeout(() => {
                globalAxios.get(`${base}nlp/data/${year}`, config)
                    .then(result => {
                        let data = result.data.articles.sort(function (a, b) {
                            return new Date(b.date) - new Date(a.date)
                        });
                        dispatch('selectedArticles', {data: data, isNew: true});
                        commit('storeArticles', data);
                        dispatch('totalSelectedArticles', data.length);
                        commit('yearArticles', year);
                    }).catch(error => console.log(error));
            }, 100)

        },
        articleSummary({commit}, myData) {
            commit('articleSummary', []);
            if (myData.body.length > 0) {
                globalAxios.post(`${base}nlp/summary`, {data: myData}, config)
                    .then(result => {
                        commit('articleSummary', result.data.summary);
                    }).catch(error => console.log(error));
            } else if (myData.url.length > 0) {
                globalAxios.post(`${base}api/summarizeit`, {data: myData}, config)
                  .then(result => {
                      commit('articleSummary', result.data.summary);
                  }).catch(error => console.log(error));
            }
            else {
                commit('articleSummary', ["Not enough text to summarize or you need to clean your document"]);

            }
        },

        recommendedArticles({commit}, article) {
            commit('recommendedArticles', []);  // reset content
            let my_article = encodeURIComponent(article.title);
            globalAxios.get(`${base}nlp/recommendation/${my_article}/${article.year}`, config)
                .then(result => {
                    commit('recommendedArticles', result.data.recommended);
                }).catch(error => console.log(error));
        },
    },
    getters: {
        newArticles(state) {
            return state.newArticles;
        },
        storedArticles(state) {
            return state.storedArticles
        },
        totalSelectedArticles(state) {
            return state.totalSelectedArticles
        },
        selectedArticles(state) {
            return state.selectedArticles
        },
        articleSummary(state) {
            return state.articleSummary
        },
        recommendedArticles(state) {
            return state.recommendedArticles
        },
        yearArticles(state) {
            return state.yearArticles
        }
    }
})
